<template lang="pug">
oembed-section(
  ref="oembed"
  can-remove
  can-edit
  block-interaction
  :oembed="section"
  @remove="$emit('removeSection', { index: sectionIndex })"
  @keyup.up="onArrowUp"
  @keyup.down="onArrowDown"
)
</template>

<script>
import OembedSection from '@/components/post/section/oembed-section'

export default {
  name: 'post-form__section--oembed',
  components: {
    OembedSection
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      default: null,
    },
  },
  methods: {
    resize() {
      return
    },
    focus() {
      this.$refs.oembed.focus()
    },
    onArrowUp(e) {
      if (e.shiftKey) {
        this.$emit('prevSection', { index: this.sectionIndex })
      }
    },
    onArrowDown(e) {
      if (e.shiftKey) {
        this.$emit('nextSection', { index: this.sectionIndex })
      }
    },
  },
}
</script>

<style lang="sass">
.post-from__section
  visibility: visible
</style>

